import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';

import { Text } from '@atlaskit/primitives/compiled';

import type { UpdateWorkItemFieldsAction } from '../../../../../common/types';

import type { flagField_updateWorkItemFieldsActionRenderer$key } from './__generated__/flagField_updateWorkItemFieldsActionRenderer.graphql';
import { isFlagged } from './utils';

const messages = defineMessages({
	flagged: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.flag-field.flagged',
		defaultMessage: 'Add flag',
		description: 'Label for the change action in the flag field',
	},
	unflagged: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.flag-field.unflagged',
		defaultMessage: 'Remove flag',
		description: 'Label for the change action in the flag field',
	},
});

export type Props = {
	queryRef: flagField_updateWorkItemFieldsActionRenderer$key;
	action: UpdateWorkItemFieldsAction;
};

export const FlagField = ({ queryRef, action }: Props): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const data = useFragment(
		graphql`
			fragment flagField_updateWorkItemFieldsActionRenderer on JiraFlagField {
				fieldId
			}
		`,
		queryRef,
	);

	if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) {
		return null;
	}

	const flagged = isFlagged(action.data.fieldValue);

	return (
		<Text
			color="color.text.subtle"
			maxLines={1}
			testId="update-work-item-fields-action-renderer.ui.action-card.card-fields-list.flag-field"
		>
			{flagged ? formatMessage(messages.flagged) : formatMessage(messages.unflagged)}
		</Text>
	);
};
